export default {"src":"/_next/static/media/instagram_contact.814b92c2.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};